import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Admin_Parivartan_Get_Category_Names } from "../../../../constants";
import axios from "axios";

const SubCategoryFilter = ({ selectedCategory, setSelectedCategory }) => {
  const [categoryNames, setCategoryNames] = useState([]);
  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(
        `${Admin_Parivartan_Get_Category_Names}`
      );
      setCategoryNames(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  return (
    <>
      <Box display="flex" gap={2} alignItems="center">
        <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="category-select-label">Category</InputLabel>
          <Select
            labelId="category-select-label"
            value={selectedCategory}
            label="Region"
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <MenuItem value="">
              <em>All Category</em>
            </MenuItem>
            {categoryNames.map((category) => (
              <MenuItem key={category.CategoryId} value={category.CategoryId}>
                {category.CategoryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export default SubCategoryFilter;
